var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nav__email-signup" }, [
    _c(
      "aside",
      { staticClass: "nav__email-signup__lightbox", style: _vm.lightboxStyle },
      [
        _c(
          "button",
          {
            staticClass: "nav__email-signup__close",
            on: { click: _vm.closeClicked }
          },
          [_c("span", [_vm._v("Close")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav__email-signup__wrapper" },
          [
            _c("h2", [_vm._v("Subscribe to ShopKeep's Small Business Hub")]),
            _vm._v(" "),
            _c("marketo", {
              attrs: { id: "1273", "class-name": "mktoSolid", cta: "Subscribe" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "nav__email-signup__rss",
            attrs: {
              href: "http://feeds.feedburner.com/shopkeep/BZWt",
              target: "_blank"
            }
          },
          [_vm._v("Small Business Hub Feed")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }